<template>
	<div class="card">
		<div style="padding: 20px">
			<span style="font-size: 24px; font-weight: 900">{{ $t("profit-overview") }}</span>
		</div>
		<div style="width: 100%">
			<apexchart type="bar" height="250" :options="chartOptions" :series="series"></apexchart>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
export default {
	name: "counter-chart",
	data() {
		return {
			series: [
				{
					name: "users",
					data: []
				},
				{
					name: "schools",
					data: []
				},
				{
					name: "payments",
					data: []
				}
			],
			chartOptions: {
				chart: {
					type: "bar",
					height: 250
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: "55%",
						endingShape: "rounded"
					}
				},
				dataLabels: {
					enabled: false
				},
				stroke: {
					show: true,
					width: 2,
					colors: ["transparent"]
				},
				xaxis: {
					categories: [""]
				},
				fill: {
					opacity: 1
				},
				legend: {
					show: true,
					floating: true
				}
			}
		}
	},

	computed: {
		...mapGetters({
			users: "dashboard/usersNumber",
			schools: "dashboard/schoolsNumber",
			payments: "dashboard/paymentsNumber"
		})
	},
	watch: {
		schools: function () {
			this.series[1].data = [this.schools.length]
		},
		users: function () {
			this.series[0].data = [this.users.length]
		},
		payments: function () {
			this.series[2].data = [this.payments.length]
		}
	}
}
</script>
<style scoped lang="scss">
.card {
	padding: 10px;
	border-radius: 15px;
	background-color: rgba(255, 255, 255, 0.7);
	width: 400px;
	&:hover {
		background-color: rgba(255, 255, 255, 1);
	}
}
</style>
